<div class="container">
    <div class="row mb-3">
        <div class="col section-title-full" role="banner">
            <h1>
                {{autorization?.title?.rendered}}
            </h1>
        </div>
    </div>
</div>

<main id="main-content" class="container mb-3">
    <div class="row">
        <div class="col-12 mb-3">
            <div class="card">
                <div [innerHTML]="autorization?.content?.rendered"></div>
            </div>
        </div>
        <div class="col-12 text-center">
            <button type="button" class="btn btn-primary" (click)="newAutorization()">
                <span i18n>Crear Solicitud</span>
            </button>
        </div>
    </div>
</main>